module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Preface#fm-1"
    }
  }, [_vm._v("Series Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Preface_1#fm-2"
    }
  }, [_vm._v("Preface to the Second Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Preface_2#fm-3"
    }
  }, [_vm._v("Preface to the First Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Texts#fm-4"
    }
  }, [_vm._v("Texts and Translations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Abbre#fm-5"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Bib#fm-6"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#pt-1"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec-1"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("   The Letter in the Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec-2"
    }
  }, [_vm._v("II."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("  Nature and Genre")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec-3"
    }
  }, [_vm._v("III."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec2-1"
    }
  }, [_vm._v("A. The Case for James of Jerusalem as the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec2-2"
    }
  }, [_vm._v("B. The Challenge to the Traditional View")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec2-3"
    }
  }, [_vm._v("C. Final Assessment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec-4"
    }
  }, [_vm._v("IV."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Occasion and Date")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec2-4"
    }
  }, [_vm._v("A. The Readers and Their Situation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec2-5"
    }
  }, [_vm._v("B. Date")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec-5"
    }
  }, [_vm._v("V."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Context of Thought and Theology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec2-6"
    }
  }, [_vm._v("A. Cognitive Environment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec2-7"
    }
  }, [_vm._v("B. James and “Theology”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec2-8"
    }
  }, [_vm._v("C. God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec2-9"
    }
  }, [_vm._v("D. Eschatology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec2-10"
    }
  }, [_vm._v("E. The Law / the Word of God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec2-11"
    }
  }, [_vm._v("F. Wisdom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec2-12"
    }
  }, [_vm._v("G. Poverty and Wealth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec2-13"
    }
  }, [_vm._v("H. The Christian Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec2-14"
    }
  }, [_vm._v("I. Faith, Works, and Justification")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Intro#sec-6"
    }
  }, [_vm._v("VI."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Structure and Theme")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Outline",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMMENTARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Outline#ch-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OUTLINE OF JAMES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMMENTARY ON JAMES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Letter Opening: Overview of Pastoral Concerns (1:1–27)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec2-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Address and Greeting (1:1)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec2-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The Pursuit of Spiritual Wholeness (1:2–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Trials and Spiritual Wholeness (1:2–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Wisdom, Faith, and Spiritual Wholeness (1:5–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Encouraging the Poor, Challenging the Rich (1:9–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Reward for Enduring Trials (1:12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Trials and Temptations (1:13–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. God’s Good and Consistent Giving (1:16–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec2-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Characteristics of Spiritual Wholeness (1:19–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Warning about Hasty Speech and Anger (1:19–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec3-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Right Response to God’s Word (1:21–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec3-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Marks of Pure and Faultless Religion (1:26–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Letter Body: Development of Pastoral Concerns (2:1–5:11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec2-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Discrimination against the Poor and the “Royal Law” (2:1–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec3-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Rebuke for Discriminating against the Poor (2:1–7)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary#sec3-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Discrimination and the Kingdom Law of Love (2:8–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015a_Commentary#sec2-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The Faith That Saves (2:14–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015a_Commentary#sec2-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Spiritual Wholeness, Speech, and Community Harmony (3:1–4:12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015a_Commentary#sec3-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The Harmful Effects of the Uncontrolled Tongue (3:1–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015a_Commentary#sec3-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Fruit of True Wisdom: Peace (3:13–4:3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015a_Commentary#sec3-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A Summons to Spiritual Wholeness (4:4–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015b_Commentary#sec3-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. A Final Rebuke of Sinful Speech (4:11–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015b_Commentary#sec2-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Arrogance, the Abuse of Wealth, and the Christian Response (4:13–5:11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015b_Commentary#sec3-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Rebuke of Arrogant Planning (4:13–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015b_Commentary#sec3-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Rebuke of the Abuse of Wealth (5:1–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015b_Commentary#sec3-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Patient Endurance in Light of the Lord’s Return (5:7–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015b_Commentary#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Letter Closing: Final Pastoral Concerns (5:12–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015b_Commentary#sec2-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Oaths and Truthfulness (5:12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015b_Commentary#sec2-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Prayer and Healing (5:13–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015b_Commentary#sec2-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. A Concluding Summons to Action (5:19–20)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42bd9c78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 72
// module chunks = 0